import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCategoriesOpen, setMobileCategoriesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Strona główna', href: '/' },
    { label: 'Poradnik zakupowy', href: '/artykul/kakobuy-spreadsheet' },
    { label: 'Sneakersy', href: '/artykul/sneakersy-kakobuy' },
    { label: 'Bezpieczeństwo', href: '/artykul/bezpieczenstwo-kakobuy' },
    { label: 'Trendy 2026', href: '/artykul/trendy-kakobuy' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-xl font-heading font-bold text-foreground-950 tracking-tight">
            Kakobuy<span className="text-primary-500">Spreadsheet</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((link) =>
            link.href.startsWith('/') ? (
              <Link
                key={link.href}
                to={link.href}
                className="text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.href}
                href={link.href}
                className="text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            )
          )}
          <div className="flex items-center gap-2 ml-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-2 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Kakobuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-foreground-950 hover:bg-foreground-800 text-background-50 px-4 py-2 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Kup teraz
            </a>
          </div>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/60 px-4 pb-4 max-h-[80vh] overflow-y-auto">
          {/* Main nav links */}
          {navLinks.map((link) =>
            link.href.startsWith('/') ? (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileOpen(false)}
                className="block py-2.5 text-sm font-medium text-foreground-700 hover:text-foreground-950"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="block py-2.5 text-sm font-medium text-foreground-700 hover:text-foreground-950"
              >
                {link.label}
              </a>
            )
          )}

          {/* Categories expandable section */}
          <div className="mt-2 pt-2 border-t border-background-200/60">
            <button
              onClick={() => setMobileCategoriesOpen(!mobileCategoriesOpen)}
              className="w-full flex items-center justify-between py-2.5 text-sm font-semibold text-foreground-800 cursor-pointer"
            >
              <span>Kategorie produktów</span>
              <i className={`ri-arrow-down-s-line text-foreground-500 transition-transform ${mobileCategoriesOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {mobileCategoriesOpen && (
              <div className="space-y-0.5 pb-2">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMobileOpen(false)}
                    className="flex items-center gap-3 py-2 px-2 rounded-md text-sm text-foreground-600 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-50 text-primary-500 shrink-0">
                      <i className={`${cat.icon} text-sm`}></i>
                    </div>
                    <span className="whitespace-nowrap">{cat.name}</span>
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* CTA buttons */}
          <div className="mt-3 pt-3 border-t border-background-200/60 flex flex-col gap-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-block text-center bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer"
            >
              Kakobuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-block text-center bg-foreground-950 hover:bg-foreground-800 text-background-50 px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer"
            >
              Kup teraz
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}